<!-- ヘッダー -->
<template>
  <header class="crly-o-common-header" @touchmove.prevent="">
    <div class="crly-o-common-header__contents left">
      <CrlyAtomsCommonHeaderLogo @clickMenuBtn="clickMenuBtn" />
    </div>
    <div class="crly-o-common-header__contents right">
      <template v-if="!isLoggedIn">
        <CrlyAtomsCommonBtnSignUp @clickMenuBtn="clickMenuBtn" />
        <CrlyAtomsCommonBtnLogin @clickMenuBtn="clickMenuBtn" />
      </template>
      <CrlyAtomsCommonBtnMenu @clickMenuBtn="clickMenuBtn" :isOpen="showMenu" />
    </div>
    <CrlyOrganismsCommonSlideMenu
      :isLogin="isLoggedIn"
      :showMenu="showMenu"
      @clickMenusClose="clickMenuBtn"
    />
  </header>
</template>

<script>
import CrlyAtomsCommonHeaderLogo from "@crly/components/atoms/common/Logo.vue";
import CrlyAtomsCommonBtnSignUp from "@crly/components/atoms/common/btn/SignUp.vue";
import CrlyAtomsCommonBtnLogin from "@crly/components/atoms/common/btn/Login.vue";
import CrlyAtomsCommonBtnMenu from "@crly/components/atoms/common/btn/Menu.vue";
import CrlyOrganismsCommonSlideMenu from "@crly/components/organisms/common/SlideMenu.vue";

export default {
  name: "CrlyOrganismsCommonHeader",
  components: {
    CrlyAtomsCommonHeaderLogo,
    CrlyAtomsCommonBtnMenu,
    CrlyAtomsCommonBtnLogin,
    CrlyAtomsCommonBtnSignUp,
    CrlyOrganismsCommonSlideMenu
  },
  data: () => ({
    /**
     * スライドメニューの表示状態
     */
    showMenu: false
  }),
  methods: {
    /**
     * メニューボタンクリックイベント
     */
    clickMenuBtn(status) {
      this.$store.commit("menuStatus/setSlideMenu", !this.showMenu);
      this.$emit("clickMenuBtn", status);
      this.showMenu = status;
    },

    /**
     * ユーザー情報取得APIを呼び出し、データを取得する
     */
    async getProfileInfo() {
      const profile = await this.$repositories('user').getUser();
      if (profile?.data) {
        //取得できた情報を$storeに格納する
        this.$store.commit('auth/setProfileMe', profile.data); 
      }
    }
  },
  watch: {
    showMenu(val) {
      if (val == false) {
        this.$store.commit("menuStatus/setCategoryMenu", false);
        this.$store.commit("menuStatus/setSlideMenu", false);
      }
    }
  },
  mounted(){
    //ログインしている場合、ユーザー情報を取得する
    if (this.isLoggedIn) {
      this.getProfileInfo();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/organisms/common/header.scss";
</style>
